import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appStringFormat]',
  exportAs: 'stringFormat'
})
export class StringFormatDirective {
  @Input('appStringFormat') stringFormat: string;
}
